import React, { useEffect, useState } from 'react';
import { DrawerBody } from '@fiverr-private/overlay';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { Skeleton, SkeletonSquare } from '@fiverr-private/feedback';
import { SparkSolidIcon } from '@fiverr-private/visuals';
import { SlideFade } from '@fiverr-private/transition';
import { AppI18n } from '../../i18n';
import { useBriefCreationContext } from '../../context/BriefCreationContext';
import { Step } from '../../constants';

export const LoadingStep = () => {
  const [isCurrentStep, setIsCurrentStep] = useState(true);
  const { currentStep } = useBriefCreationContext();
  useEffect(() => {
    setIsCurrentStep(currentStep === Step.Loading);
  }, [currentStep]);

  return (
    <DrawerBody>
      <SlideFade
        in={isCurrentStep}
        reverse
        duration={{
          enter: 'fast3',
          exit: 'slow3',
        }}
        easing={'easeOut'}
      >
        <Stack direction="column" width="100%" gap="8">
          <Stack direction="row" gap="3" alignItems="center">
            <SparkSolidIcon size="md" color="grey_1200" />
            <Text fontWeight="semibold" size="b_md">
              <AppI18n k="drawer_header_loading" />
            </Text>
          </Stack>
          <Skeleton width="100%">
            <Stack direction="column" gap="5">
              <SkeletonSquare height="40px" width="100%" />
              <SkeletonSquare height="20px" width="100%" />
              <SkeletonSquare height="20px" maxWidth="320px" />
              <SkeletonSquare height="20px" maxWidth="320px" />
            </Stack>
          </Skeleton>
        </Stack>
      </SlideFade>
    </DrawerBody>
  );
};
